/**
 * wcag.js
 * 
 * WCAG-related JavaScript functions
 * 
 * @author jjarolim
 */

import { init as initFocusTraps } from './wcag/focus-trap';
import { init as initKeyboardUsageIndicators } from './wcag/keyboard-usage-indicator';

const init = () => {
    initKeyboardUsageIndicators();
    initFocusTraps();
}

export { init };


